import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Spinner from 'react-spinner-material';

import { FaFilter } from 'react-icons/fa';
import { MdImportExport, MdDeleteForever } from 'react-icons/md';

import Dialog from 'react-bootstrap-dialog';

import "react-table/react-table.css";
import "../css/style.css";

import { DATA_TYPE_CK, WO_COMPLETED_CK, WO_READY, WO_EXPORTED_CK, ERROR_CODE_LOI_CAT_KHAC_TK, ERROR_CODE_LOI_CAT_KHAC, WO_TOBE_FIXED, WO_ASSIGNED_WORKER, WO_NHAM, WO_BONG, WO_QUAYKIM } from '../constants';
import MenuComponent2 from './MenuComponent2';

import WorkOrderUtil from '../utilities/WorkOrderUtil';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR} from '../icon';
import queryString from 'query-string'
import UserDataService from '../services/UserDataService';
import { Multiselect } from 'multiselect-react-dropdown';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import WorkOrderImages from './WorkOrderImages';
import WorkOrderAdditions from './WorkOrderAdditions';
import NoteDataService from '../services/NoteDataService';
import Modal from 'react-bootstrap/Modal'

class KhacList extends Component {
  constructor () {
    super();
    
    const numOfMonths = 24;
    let fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000*3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      page: 0,
      loading: false,
      pages: 0,
      pageSize: 10,
      selected: [],
      selectedPage: 0,
      spinnerVisible: false,
      allStatus: [],
      fromDate: fromDate,
      toDate: toDate,
      status: '0', 
      assignOnly: '0',
      country: null, 
      customer: null, 
      orderNo: null, 
      woStatus: 0,
      workOrders: [],
      childRefreshCount: 0,
      worker: [],
      selectedWorker: 0,
      workerName: '',
      woStatusList: [],
      selectedWoStatusList: [],
      columns : [],
      show: false,
      workOrder: {},
      pcode: '',
      personalization: '',
      sortBy: 'assignedAt',
      sortType: 'asc'              
    };
  }

  handleEdit(e){
    this.showWorkOrdersByNo(e.original.workOrderNo);
  }  
  

  linkToDetails(row){
      return(
          <label className="label_link" href="#!" onClick={() => {this.handleEdit(row)}}>{row.original.workOrderNo}</label>
      )
  }

  handleSelectAllClick() {
    if (this.state.selectAll === '1') {
      this.setState({ selectAll: '0', selectedWoStatusList: [], woSubStatus: undefined });
    } else {
      let allStattus = this.state.woStatusList;
      this.setState({ selectAll: '1', selectedWoStatusList: allStattus, woSubStatus: undefined });
    }
  }
  
  onSelect(selectedList, selectedItem) {
    this.setState({
      selectedWoStatusList: selectedList
    });
  }
  
  onRemove(selectedList, removedItem) {
    this.setState({
      selectedWoStatusList: selectedList
    });    
  }

  changeCK(e){
    let ret = window.confirm(couterpart.translate('msg_wait_vck_change_confirm'));
    if (ret === true){
      WorkOrderDataService.changeToCatKhac([e.original.id]).then(data => {
        if (data.message === undefined){
          this.filterOrdersBy()
        }
      });
    }
  }

  loadWorker(){
      if (AuthenticationService.isAdmin() || AuthenticationService.isService() || AuthenticationService.isKhac() || AuthenticationService.isSupervisor()){
          UserDataService.retrieveWorkers().then(data => {
              let len = data.length;
              let worker = [];
              for(let i=0; i<len; i++){
                  worker.push({key:data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id, userName: data[i].userName })
              }
              this.setState({worker: worker});
          });
      }
  }  

  componentDidMount () {
    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ 
        allStatus:  data,
        woStatusList: [
          { id: WO_COMPLETED_CK, name: WorkOrderUtil.getStatusDescription(data, WO_COMPLETED_CK)},
          { id: WO_READY, name: WorkOrderUtil.getStatusDescription(data, WO_READY)},
          { id: WO_ASSIGNED_WORKER, name: WorkOrderUtil.getStatusDescription(data, WO_ASSIGNED_WORKER)},
        ],
        columns : [
          {
            id: "idx",
            accessor: "",
            width: 40,
            Cell: row =>(
              <div style={{ padding: "10px"}}>{row.index + 1 + (this.state.selectedPage * this.state.pageSize)}</div>
            )
          },{
            id: "checkbox",
            accessor: "",
            Cell: ({ original }) => {
              return (
                <div style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selected[original.id] && this.state.selected[original.id].checked === true}
                  onChange={() => this.toggleRow(original)}
                /></div>
              );
            },
            Header: x => {
              return (
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selectAll === 1}
                  ref={input => {
                    if (input) {
                      input.indeterminate = this.state.selectAll === 2;
                    }
                  }}
                  onChange={() => this.toggleSelectAll()}
                />
              );
            },
            sortable: false,
            width: 45
          },{
            Header: couterpart.translate('work_order_urgent_level'),
            accessor: 'isUrgentByCustomer',
            width: 50,
            Cell: row => {
              row.styles['color'] = row.value === 1 ? 'red' : 'black';
              return row.value === 1 ? 'X' : '';
            },           
            filterable: false,
            filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)             
          },{
            Header: couterpart.translate('work_order_no'),
            accessor: 'workOrderNo',
            width: 150,
            Cell: row =>(
              this.linkToDetails(row)
            )
          },{
            Header: couterpart.translate('work_order_code'),
            accessor: 'sku',
            filterable: false,
            width: 200
          },{           
            Header: couterpart.translate('shop_pcode'),
            accessor: 'fullPCode',
            filterable: false,
            width: 80                                                      
          },{
            Header: 'MT',
            accessor: 'fimg',
            width: 150,
            sortable: false,
            Cell: row =>(
              this.fImageRender(row)
            )
          },{
            Header: 'MS',
            accessor: 'bimg',
            width: 150,
            sortable: false,
            Cell: row =>(
              this.bImageRender(row)
            )
          },{
            Header: couterpart.translate('work_order_worker'),
            accessor: 'workerFullName',
            filterable: false,
            width: 70            
          },{
            Header: couterpart.translate('work_order_size'),
            accessor: 'lengthSize',
            filterable: false,
            width: 50
          },{
            Header: couterpart.translate('item_mota'),
            accessor: 'personalization',
            filterable: false,
            sortable: false,
            width: 200
          },{
            Header: couterpart.translate('ckfiles_corel_s'),
            accessor: 'corel',
            sortable: false,
            width: 200                                                           
          },{
            Header: couterpart.translate('item_assigned_to'),
            accessor: 'designer',
            filterable: false,
            sortable: true,
            width: 100          
          },{
            Header: couterpart.translate('work_order_ckExportFile'),
            accessor: 'ckExportFile',
            sortable: false,
            width: 200                                        
          },{          
            Header: couterpart.translate('work_order_status'),
            accessor: 'status',
            width: 150,
            Cell: props => WorkOrderUtil.getStatusDescription(data, props.value)
          },{          
            Header: couterpart.translate('work_order_suco'),
            accessor: 'fillSKU',
            width: 250,
            Cell: row =>(
                <div style={{ textAlign: "center" }}>
                    {this.renderSuco(row)}
                </div>
            )
          }, {
            Header: couterpart.translate('wo_semi'),
            accessor: 'semi',
            filterable: false,
            width: 50
          }, {
            Header: couterpart.translate('wo_donmua'),
            accessor: 'donMua',
            filterable: false,
            width: 100
          }, {
            Header: couterpart.translate('wo_hangiaomua'),
            accessor: 'hanGiaoMua',
            filterable: false,
            width: 150                                                                        
          },{           
              Header: couterpart.translate('work_order_action'),
              accessor: 'action',
              width: 90,
              Cell: row =>(
                <div style={{ textAlign: "center" }}>
                    {this.renderEditButton(row)}
                </div>
              )
        }]
      }) 
    });

    this.loadWorker();
    
    let fromDate =  WorkOrderUtil.getItem("prodKhac.fromDate")
    let toDate = WorkOrderUtil.getItem("prodKhac.toDate")
    let incident = WorkOrderUtil.getItem("prodKhac.incident");

    const values = queryString.parse(this.props.location.search);
    let numOfMonths = 12;
    if (values !== undefined && values.status !== undefined){
      numOfMonths = 24;
    }

    if (values === undefined || (values.status === undefined && values.isback === undefined)){
      WorkOrderUtil.removeItem('prodKhac.woStatus');
    }
  
    if (values === undefined || (values.status === undefined && values.isback === undefined) || fromDate === null || fromDate === undefined) {
      let backTime = 30*24*60*60*1000*numOfMonths;
      fromDate = new Date(new Date().getTime() - backTime);//1 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date();
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    let swoStatusList = WorkOrderUtil.getItem('prodKhac.selectedWoStatusList');
    let woStatusList = [];
    try{
      woStatusList = JSON.parse(swoStatusList)
    }catch(ec){
    }

    console.log('woStatusList', woStatusList);   

    let semi = WorkOrderUtil.getItem("prodKhac.semi");
    let ignoreSemi = '1';
    
    if (semi == 0 || semi == 1){
      ignoreSemi = '-1';
    }

    let pcode =  WorkOrderUtil.getItem('prodKhac.pcode')? WorkOrderUtil.getItem('prodKhac.pcode') : '';
    let personalization =  WorkOrderUtil.getItem('prodKhac.personalization')? WorkOrderUtil.getItem('prodKhac.personalization') : '';      
    let sortBy =  WorkOrderUtil.getItem('prodKhac.sortBy')? WorkOrderUtil.getItem('superv.sortBy') : 'assignedAt';
    let sortType =  WorkOrderUtil.getItem('prodKhac.sortBy')? WorkOrderUtil.getItem('superv.sortType') : 'asc'; 
    let donMuaSearch = WorkOrderUtil.getItem('prodKhac.donMuaSearch'); 
    let hanGiaoMuaSearch = WorkOrderUtil.getItem('prodKhac.hanGiaoMuaSearch');
    let hanGiaoMuaEndSearch = WorkOrderUtil.getItem('prodKhac.hanGiaoMuaEndSearch');

    this.setState({ 
      fromDate:  fromDate, 
      toDate: toDate, 
      orderNo: WorkOrderUtil.getItem("prodKhac.orderNo"),
      woStatus: WorkOrderUtil.getItem("prodKhac.woStatus") ? WorkOrderUtil.getItem("prodKhac.woStatus") : 0,
      workerName: WorkOrderUtil.getItem("prodKhac.workerName") ? WorkOrderUtil.getItem("prodKhac.workerName") : '',
      selectedWoStatusList: woStatusList,
      semi: semi,
      ignoreSemi: ignoreSemi,
      pcode:  pcode,
      personalization: personalization,
      sortBy: sortBy,
      sortType: sortType,
      incident: incident,
      donMua: donMuaSearch,
      hanGiaoMua: hanGiaoMuaSearch,
      hanGiaoMuaEnd: hanGiaoMuaEndSearch 

    }, () => {
      this.filterOrdersBy();
    });
  
  }

  renderEditButton(row){
    if (row.original.status === WO_COMPLETED_CK || row.original.status !== WO_READY){ //Da cat khac
      return (<></>);
    }

    if (AuthenticationService.isKhac()){
      return (<div>
              <button className="myButton" onClick={() => this.changeCK(row)}>
              <MdDeleteForever color={ICON_COLOR}/>
              &nbsp;{ couterpart.translate('button_ck') }</button>
                </div>
              );
    }else{
      return (<></>);
    }
  }

  renderSuco(row){
    if (row.original.fillSKU === null || row.original.fillSKU == undefined){
      return (<label>{ "" }</label>);
    }

    if (row.original.fillSKU.substring(0, 2) === 'Y$'){
      return (<label style= {{ backgroundColor: 'red' }}>{ row.original.fillSKU }</label>);
    }
    return (<label>{ row.original.fillSKU }</label>);
  }   

  fImageRender(row){
    if (row.original.fimg === undefined || row.original.fimg === null){
      return (<></>)
    }
    return(
        <img className="imageBox linkTo" alt="" width={ 100 } height={70} src={`data:image/jpeg;base64,${row.original.fimg}`} name={'F' + row.original.workOrderNo} />
    )
  }

  bImageRender(row){
    if (row.original.bimg === undefined || row.original.bimg === null){
      return (<></>)
    }    
    return(
        <img className="imageBox linkTo" alt="" width={ 100 } height={70} src={`data:image/jpeg;base64,${row.original.bimg}`} name={ 'B' + row.original.workOrderNo} />
    )
  }   

  toggleRow(row) {
    let newSelected = Object.assign({}, this.state.selected);
    if (newSelected[row.id] === undefined){
      newSelected[row.id] = {checked: true, status: row.status, shipCode: row.shipCode, ckExportFile: row.ckExportFile, workOrderNo: row.workOrderNo, fillSKU: row.fillSKU};
    }

    if (this.state.selected[row.id]){
      newSelected[row.id].checked = !this.state.selected[row.id].checked;
      newSelected[row.id].status = this.state.selected[row.id].status;
      newSelected[row.id].shipCode = this.state.selected[row.id].shipCode;
      newSelected[row.id].ckExportFile = this.state.selected[row.id].ckExportFile;
      newSelected[row.id].workOrderNo = this.state.selected[row.id].workOrderNo;
      newSelected[row.id].fillSKU = this.state.selected[row.id].fillSKU;
    }

		this.setState({
			selected: newSelected,
			selectAll: 2
		}, () =>{
      WorkOrderUtil.saveItem('prodKhac.selected', JSON.stringify(this.state.selected));
    });
	}

	toggleSelectAll() {
		const newSelected = Object.assign({}, this.state.selected);
		if (this.state.selectAll === 0 || this.state.selectAll === undefined) {
			this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined){
          newSelected[x.id] = {checked: true, status: x.status, shipCode: x.shipCode, ckExportFile: x.ckExportFile, workOrderNo: x.workOrderNo, fillSKU: x.fillSKU};
        } else {        
          newSelected[x.id].checked = true;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
          newSelected[x.id].ckExportFile = x.ckExportFile;
          newSelected[x.id].workOrderNo = x.workOrderNo;
          newSelected[x.id].fillSKU = x.fillSKU;
        }
			});
		} else {
			this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined){
          newSelected[x.id] = {checked: false, status: x.status, shipCode: x.shipCode, fillSKU: x.fillSKU};
        } else {        
          newSelected[x.id].checked = false;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
          newSelected[x.id].ckExportFile = x.ckExportFile;
          newSelected[x.id].workOrderNo = x.workOrderNo;
          newSelected[x.id].fillSKU = x.fillSKU;
        }
			});
    }

		this.setState({
			selected: newSelected,
			selectAll: this.state.selectAll === 0 ? 1 : 0
		}, () =>{
      WorkOrderUtil.saveItem('prodKhac.selected', JSON.stringify(this.state.selected));
    });
	}  
  
  clearSearchInfo() {
    WorkOrderUtil.removeItem("prodKhac.fromDate")
    WorkOrderUtil.removeItem("prodKhac.toDate")
    WorkOrderUtil.removeItem("prodKhac.orderNo")
    WorkOrderUtil.removeItem("prodKhac.woStatus")
    WorkOrderUtil.removeItem("prodKhac.workerName")
    WorkOrderUtil.removeItem("prodKhac.selectedWoStatusList");
    WorkOrderUtil.removeItem("prodKhac.semi");
    WorkOrderUtil.removeItem("prodKhac.pcode");
    WorkOrderUtil.removeItem("prodKhac.personalization");
    WorkOrderUtil.removeItem("prodKhac.sortBy");
    WorkOrderUtil.removeItem("prodKhac.sortType");
    WorkOrderUtil.removeItem("prodKhac.selected");
    WorkOrderUtil.removeItem("prodKhac.incident");
    WorkOrderUtil.removeItem("prodKhac.donMuaSearch");
    WorkOrderUtil.removeItem("prodKhac.hanGiaoMuaSearch");
    WorkOrderUtil.removeItem("prodKhac.hanGiaoMuaEndSearch");
  }
  saveSearchInfo(fromDate, toDate, orderNo, selectedWoStatusList, workerName, semi, pcode, personalization, sortBy, sortType, incident, donMuaSearch, hanGiaoMuaSearch, hanGiaoMuaEndSearch){
    WorkOrderUtil.saveItem("prodKhac.fromDate", fromDate);
    WorkOrderUtil.saveItem("prodKhac.toDate", toDate);  
    WorkOrderUtil.saveItem("prodKhac.orderNo", orderNo);
    WorkOrderUtil.saveItem("prodKhac.workerName", workerName);
    WorkOrderUtil.saveItem("prodKhac.selectedWoStatusList", JSON.stringify(selectedWoStatusList));
    WorkOrderUtil.saveItem("prodKhac.semi", semi);
    WorkOrderUtil.saveItem("prodKhac.pcode", pcode); 
    WorkOrderUtil.saveItem("prodKhac.personalization", personalization); 
    WorkOrderUtil.saveItem("prodKhac.sortBy", sortBy);
    WorkOrderUtil.saveItem("prodKhac.sortType", sortType);
    WorkOrderUtil.saveItem("prodKhac.incident", incident);
    WorkOrderUtil.saveItem("prodKhac.donMuaSearch", donMuaSearch);
    WorkOrderUtil.saveItem("prodKhac.hanGiaoMuaSearch", hanGiaoMuaSearch);
    WorkOrderUtil.saveItem("prodKhac.hanGiaoMuaEndSearch", hanGiaoMuaEndSearch);    
  }

  onFilter() {
    this.clearSearchInfo();
    this.setState({ page: 0, selected: {} }, 
      () => {
        this.filterOrdersBy();
    });    
  }

  filterOrdersBy(){
    if ((this.state.selectedPage < 0) || (this.state.pageSize < 0)){
      return;
    }

    this.setState({ loading: true });
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;
    let workerName = this.state.workerName;
    let orderNo = this.state.orderNo;
    let selectedWoStatusList = this.state.selectedWoStatusList;

    let selectedWoStatusCodes = [];
    if (selectedWoStatusList){
      for(let i=0; i<selectedWoStatusList.length; i++){
        selectedWoStatusCodes.push(selectedWoStatusList[i].id);
      }  
    }

    let incident = this.state.incident;

    if (incident !== 'Y'){
      if (selectedWoStatusCodes.length < 1){
        selectedWoStatusCodes = [WO_READY, WO_COMPLETED_CK, WO_ASSIGNED_WORKER];
      }
    }

    let semi = this.state.semi;
    let ignoreSemi = this.state.ignoreSemi;  

    let page = this.state.selectedPage;
    let pageSize = this.state.pageSize;
    let selected = this.state.selected; 

    let pcode = this.state.pcode;
    let personalization = this.state.personalization;        
    let sortBy = this.state.sortBy;
    let sortType = this.state.sortType;
    let donMuaSearch = this.state.donMuaSearch;
    let hanGiaoMuaSearch = this.state.hanGiaoMuaSearch;
    let hanGiaoMuaEndSearch = this.state.hanGiaoMuaEndSearch;

    let info = {
      fromDate: fromDate,
      toDate: toDate,
      orderNo: orderNo,
      isFull: 0,
      workerName: workerName,
      woStatusList: selectedWoStatusCodes,
      woErrorList: [ERROR_CODE_LOI_CAT_KHAC_TK, ERROR_CODE_LOI_CAT_KHAC],
      semi: semi,
      ignoreSemi: ignoreSemi,
      page: page === undefined? 0: page,
      pageSize: pageSize === undefined? 10: pageSize,
      dataType: DATA_TYPE_CK,
      pcode: pcode,
      personalization: personalization,
      sortBy: sortBy,
      sortType: sortType,
      incident: incident,
      donMua: donMuaSearch,
      hanGiaoMua: hanGiaoMuaSearch,
      hanGiaoMuaEnd: hanGiaoMuaEndSearch            
    };

    console.log('INFO', info);

    WorkOrderDataService.fetchWorkOrders(info)
      .then(data => {
      if(data.message === undefined && data.data !== undefined &&  data.data instanceof Array){    
        this.setState({ workOrders:  data.data, spinnerVisible: false, loading: false, pages: data.pages, page: page, pageSize: pageSize, selected: selected},
        () => {
          this.saveSearchInfo(fromDate, toDate, orderNo, selectedWoStatusList, workerName, semi, pcode, personalization, sortBy, sortType, incident, donMuaSearch, hanGiaoMuaSearch, hanGiaoMuaEndSearch);
        });
      }else{
        this.setState({ workOrders:  [], loading: false, pages: 0, page: 0, pageSize: pageSize, selected: selected});
        ToastsStore.error(data.message);
      }   
    });
  } 

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  handleFromDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      fromDate: sDate                   
    });
  }

  handleToDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      toDate: sDate                   
    });
  }

  handleStatusChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({                 
      status: value                   
    });
  }

  handleWoChangeStatusChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({                 
      woChangedStatus: value                   
    });
  }  

  handleCountryChange(e){
    let value = e.target[e.target.selectedIndex].value;
    WorkOrderUtil.saveItem("prodKhac.country", value)
    this.setState({                 
      country: value                   
    });
  }

  handleCustomerChange(e){
    let value = e.target.value;
    this.setState({                 
      customer: value                   
    });
  }

  handleOrderNoChange(e){
    let value = e.target.value;
    this.setState({                 
      orderNo: value                   
    });
  }

  handlePcodeChange(e){
    let value = e.target.value;
    this.setState({                 
      pcode: value                   
    });
  }

  handlePersonalizationChange(e){
    let value = e.target.value;
    this.setState({                 
      personalization: value                   
    });
  }  


  handleWorkerNameChange(e){
    let value = e.target.value;
    this.setState({                 
      workerName: value                   
    });
  }

  renderWoChangeStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }
   
    return(
      <select onChange={this.handleWoChangeStatusChange.bind(this)} className="selectBox2" 
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        { this.state.allStatus.filter(y =>{
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }  

  exportWorkOrders (infos) {
    this.setState({
      selectedWorkOrders: infos
    });
  }

  handleSelectChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      workerName: value
    });
  };

  handleSelectSemiChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      semiRequired: value
    });
  }

  renderWorkerOption(option){
      return (
          <option key={option.key} value={option.userName}>{option.userName}</option>
      );
  }

  handleAssignWorkerOnlyClick(){
    if (this.state.assignOnly === '1'){
      this.setState({assignOnly: '0'});
    } else {
      this.setState({assignOnly: '1'});
    }
  }

  handleSemiClick(){
    if (this.state.semi === '1'){
      this.setState({semi: '0', ignoreSemi: '-1'});
    } else {
      this.setState({semi: '1', ignoreSemi: '-1'});
    }
  }

  handleIgnoreSemiClick(){
    if (this.state.ignoreSemi === '1'){
      this.setState({semi: '0', ignoreSemi: '0'});
    } else {
      this.setState({semi: '-1', ignoreSemi: '1'});
    }
  }

  handleIncidentClick(){
    if (this.state.incident === 'Y'){
      this.setState({incident: ''});
    } else {
      this.setState({incident: 'Y'});
    }
  }  

  renderWorkers(){
      if((this.state.worker === undefined) || (this.state.selectOptions === null)){
          return (<></>);
      }
      return(
      <>
        <select onChange={this.handleSelectChange.bind(this)} className="select_margin">
            <option key="" value=""></option>
            {this.state.worker !== undefined && this.state.worker.map(option =>this.renderWorkerOption(option))}
        </select>&nbsp;&nbsp;
      </>
      );
  }

  renderSemi(){
      return(
      <>
        <select onChange={this.handleSelectSemiChange.bind(this)} className="select_margin">
            <option key="semi_no" value="0">Không Semi</option>
            <option key="semi_yes" value="1">Semi</option>
        </select>&nbsp;&nbsp;
      </>
      );
  }       

  handleSetStatusChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({                 
      newStatus: value                   
    }));
  }

  handleWorkOrderNoteChange(e){
    let newValue = e.target.value;
    this.setState(prevState => ({                 
      workOrderNote: newValue                   
    }));
  }

  changeWorkOrdersToCK(){
    let selectedItems = [];
    let notApprovedCount = 0;
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true){
          if (this.state.selected[key].status !== WO_READY && this.state.selected[key].status !== WO_TOBE_FIXED){
            notApprovedCount++;
          } else {
            selectedItems.push(parseInt(key));
          }        
        }
      }
    }

    if (selectedItems.length < 1 || notApprovedCount > 0) {
      alert(couterpart.translate('error_selected_ready_items_empty'));
      return;
    }

    let ret = window.confirm(couterpart.translate('msg_wait_vck_change_confirm'));
    if (ret === true){
      WorkOrderDataService.changeToCatKhac(selectedItems).then(data => {
        if (data.message === undefined){
          this.setState({selected: {}}, () => {
            this.filterOrdersBy();
          });
        }
      });
    }
  }

  changeWorkOrdersToKt(){
    let selectedItems = [];
    // let notApprovedCount = 0;
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true){
          selectedItems.push(parseInt(key));       
        }
      }
    }

    if (selectedItems.length < 1) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    let ret = window.confirm(couterpart.translate('msg_wait_vck_change_confirm'));
    if (ret === true){
      WorkOrderDataService.changeToKiemTra(selectedItems).then(data => {
        if (data.message === undefined){
          this.setState({selected: {}}, () => {
            this.filterOrdersBy();
          });
        }
      });
    }
  }     

  exportExcel(){
    try
    {
      let selectedItems = [];
      // if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      //   for (let key in this.state.selected) {
      //     if (this.state.selected[key].checked === true && this.state.selected[key].status !== WO_READY){
      //       selectedItems.push(parseInt(key));
      //     }
      //   }
      // }

      if (selectedItems.length < 1) {
        alert(couterpart.translate('error_selected_items_empty'));
        return;
      }

      WorkOrderDataService.getDesignerExportedInfo(selectedItems, DATA_TYPE_CK).then(existedRes => {
        console.log('getDesignerExportedInfo', existedRes);
        let oldExportedIds = [];
        let existedFiles = '';
        let sep = '';


        if (existedRes && existedRes.exportInfoList && existedRes.exportInfoList.length > 0){
          for(let i=0; i<existedRes.exportInfoList.length; i++){
            oldExportedIds.push(existedRes.exportInfoList[i].id);
            existedFiles += sep + existedRes.exportInfoList[i].filename;
            sep = ',';
          }
        }
        console.log(existedFiles);

        if (oldExportedIds.length > 0){
          let answ = window.confirm('Work orders ('+ existedRes.exportedWorkOrderList.join() + ') đã exported (' + existedFiles + '). Bạn có muốn export lại?');
          if(!answ){
            this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
            return;
          }
        }      

        UserDataService.retrieveNextFilename(DATA_TYPE_CK).then(res => {

          this.setState({spinnerVisible: true}, () =>{
            WorkOrderDataService.exportExcelForCk(selectedItems, res.filename, res.id, oldExportedIds, DATA_TYPE_CK).then(data =>{
              this.setState({selected: {}}, () => {
                this.filterOrdersBy();
              });
              
              const downloadUrl = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', res.filename);
              document.body.appendChild(link);
              link.click();
              link.remove();
              this.sleep(100).then(() => {this.setState({spinnerVisible: false});});  
            });
          });
        });
      });        
    } catch(e) {
        this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
    }        
  }

  renderReadyButton(){
    if (this.checkSelectedStatus() === 2){
      return (<></>);
    }

    return(
      <button className="myButton" 
        onClick={this.changeToReady.bind(this)}>
        <MdImportExport color={ICON_COLOR}/>
        &nbsp;{couterpart.translate('button_ready')}
      </button>
    )
  }

  checkSelectedStatus(){
    let  xuatCkCount = 0;
    let otherCount = 0;
    for(let i=0; i<this.state.selectedWoStatusList.length; i++){
      if (this.state.selectedWoStatusList[0].id === WO_EXPORTED_CK){
        xuatCkCount ++;
      } else {
        otherCount ++;
      }
    }
    if (xuatCkCount > 0 && otherCount > 0){
      return 3; //All
    }

    if (xuatCkCount > 0 && otherCount <= 0){
      return 1 //To be assigned
    }

    if (xuatCkCount <= 0 && otherCount > 0){
      return 2 //Can be changed
    }    
    return 0
  }

  renderChangeWorkerButton(){
    let check = this.checkSelectedStatus();
    if (check === 1){ //to be assigned
      return (
        <button className="myButton" 
          onClick={this.changeWorker.bind(this, 0)}>
          <MdImportExport color={ICON_COLOR}/>
          &nbsp;{couterpart.translate('button_change_worker')}
        </button>     
      );
    } 

    if (check === 2){ //to be assigned
      return(
        <button className="myButton" 
          onClick={this.changeWorker.bind(this, 1)}>
          <MdImportExport color={ICON_COLOR}/>
          &nbsp;{couterpart.translate('button_change_worker_only')}
        </button>
      ) 
    }

    return(
      <>
        <button className="myButton" 
          onClick={this.changeWorker.bind(this, 0)}>
          <MdImportExport color={ICON_COLOR}/>
          &nbsp;{couterpart.translate('button_change_worker')}
        </button>       
        <button className="myButton" 
          onClick={this.changeWorker.bind(this, 1)}>
          <MdImportExport color={ICON_COLOR}/>
          &nbsp;{couterpart.translate('button_change_worker_only')}
        </button>
      </>
    )     

  }

  handleClose(){
    this.setState({ show: false },
    () => {
      // this.sleep(500).then(() => {
      //     this.scanWorkOrderNo.focus();
      // })
    });
  }

  showWorkOrdersByNo(no){   
    WorkOrderDataService.scanByNo(no).then(data => {
      this.setState({ 
          workOrder:  data
      }, () =>{
        NoteDataService.retrieveNotesByWorkOrder(this.state.workOrder.id).then(data =>{
          this.setState({ 
              notes: data,
              show: true
          }); 
        });
      });
    });
  }

  renderWoDetails(){
    return(
    <div className="row">
      <div className="col-8">
          <div className="row">
              <div className="col-3 border-top border-left border-light-gray">
                  <div className="row">
                      <div className="col-2">
                        <img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode}/>
                      </div>
                  </div>
                  <div className="row">
                      <div className="col-2">
                        <label style={{ "marginLeft": '2px'}}>{this.state.workOrder.workOrderNo}</label>
                      </div>
                  </div>
              </div>
              <div className="col-1 border-top border-left border-light-gray">
                  <div className="row border-bottom border-light-gray">
                      <label className="labelBox_red">{couterpart.translate('work_order_urgent_level')}</label>
                  </div>
                  <div className="row">
                      <label style={{color:'red', margin: '2px'}}>{this.state.workOrder.urgent}</label>
                  </div>                        
              </div>
              <div className="col-3 border-top border-left border-light-gray">
                <div className="row border-bottom border-light-gray">                    
                    <div className="col">
                        <label className="labelBox">{couterpart.translate('work_order_order_date_s')}</label>
                    </div>
                </div>
                <div className="row border-bottom border-light-gray">
                    <div className="col">
                        <label className="labelBox">
                            {couterpart.translate('work_order_web_dealine')}
                        </label>
                    </div>
                </div>
                <div className="row border-light-gray">                            
                    <div className="col">
                        <label className="labelBox">{couterpart.translate('work_order_prod_dealine')}</label>
                    </div>                           
                </div>
              </div>
              <div className="col-3 border-top border-left border-right border-light-gray">
                  <div className="row border-bottom border-light-gray">                    
                      <div className="col border-light-gray">
                          <label className="labelValueBox">
                              {WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.orderDate)}
                          </label>
                      </div>
                  </div>
                  <div className="row border-bottom border-light-gray">
                      <div className="col border-light-gray">
                          <label className="labelValueBox">
                              { WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineWeb) } 
                          </label>
                      </div>
                  </div>
                  <div className="row border-light-gray">                            
                      <div className="col border-light-gray">
                          <label className="labelValueBox">
                              { WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineTs) }
                          </label>
                      </div>                            
                  </div>
              </div>
          </div>                        
          <div className="row">
              <div className="col-1 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_code')}</label>
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{ this.state.workOrder.sku  }</label>
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('shop_pcode')}</label>
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelValueBox">{this.state.workOrder.fullPCode}</label>
              </div>                            
              <div className="col-1 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_font')}</label>
              </div>
              <div className="col-2 border-top border-left border-right border-light-gray">
                  { this.state.workOrder.font }
              </div>
          </div>
          <div className="row">
              <div className="col-1 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_color')}</label>
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                  { this.state.workOrder.colorMaterial }
              </div>
              <div className="col-1 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_type')}</label>
              </div>
              <div className="col-3 border-top border-left border-light-gray">
                  { this.state.workOrder.shapeDesign }
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox_red">{couterpart.translate('work_order_urgent_by_cust')}</label>
              </div>
              <div className="col-1 border-top border-left border-right border-light-gray">
                { this.state.workOrder.isUrgentByCustomer }
              </div>                            
          </div>
          <div className="row">
              <div className="col-1 border-top border-left border-light-gray">
                  <label className="labelBox_red">{couterpart.translate('work_order_quantity_s')}</label>
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                { this.state.workOrder.qty }
              </div>
              <div className="col-1 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_size')}</label>
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                { this.state.workOrder.lengthSize }
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_shipto')}</label>
              </div>
              <div className="col-2 border-top border-left border-right border-light-gray">
                { this.state.workOrder.shipTo }
              </div>                                
          </div>
          <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_customer_s')}</label>
              </div>
              <div className="col-3 border-top border-left border-light-gray">
                  <label className="labelValueBox">{ this.state.workOrder.customer }</label>
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_urgent')}</label>
              </div>
              <div className="col-3 border-top border-left border-right border-light-gray">
                  { this.state.workOrder.carrierServiceRequested }
              </div>
          </div>
          <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_design_level')}</label>
              </div>
              <div className="col-1 border-top border-left border-right border-light-gray">
                  { this.state.workOrder.type }
              </div>
              <div className="col-1 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_designer')}</label>
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                  { this.state.workOrder.designers }
              </div>
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_ngay_nhap_lieu')}</label>
              </div>
              <div className="col-2 border-top border-left border-right border-light-gray">
                  <label className="labelValueBox">{
                      WorkOrderUtil.formatShortDisplayDateMMddyyyy2(this.state.workOrder.ngayNhapLieu) 
                  }</label>
              </div>                                                         
          </div>
          <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">
                      {couterpart.translate('work_order_personalization')}
                  </label>
              </div>
              <div className="col-8 border-top border-left border-right border-light-gray">
                { this.state.workOrder.personalization }
              </div>                          
          </div>
          <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_special_note')}</label>
              </div>
              <div className="col-8 border-top border-left border-right border-light-gray">
                { this.state.workOrder.notesInternal? this.state.workOrder.notesInternal : '' }
              </div>
          </div>
          <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{couterpart.translate('work_order_ycdb_shipping')}</label>
              </div>
              <div className="col-8 border-top border-left border-right border-light-gray">
                { this.state.workOrder.ycdbShipping? this.state.workOrder.ycdbShipping : '' }
              </div>
          </div>                        
          <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">
                      {couterpart.translate('label_note')}
                  </label>
              </div>
              <div className="col-8 border-top border-left border-right border-light-gray">
                { this.state.workOrder.notesFromService? this.state.workOrder.notesFromService : '' }
              </div>
          </div>                        
          <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">
                      { couterpart.translate('work_order_status') }
                  </label>
              </div>
              <div className="col-8 border-top border-left border-right border-light-gray">
                  { this.state.workOrder.status }
              </div>
          </div>                                                 
          <div className="row">
              <div className="col-10 border-top border-left border-right border-bottom border-light-gray">
                  <br/>
                  <ExpansionPanel>
                      <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      >
                      <Typography>{couterpart.translate('work_order_original_info')}</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <p>
                              {couterpart.translate('work_order_quantity_s')}: {this.state.workOrder.originalQty} <br/>
                              {couterpart.translate('work_order_code')}: {this.state.workOrder.originalSKU} <br/>
                              {couterpart.translate('work_order_urgent')}: {this.state.workOrder.originalServiceRequested}<br/>
                              {couterpart.translate('work_order_options')}: {this.state.workOrder.options}<br/>
                              {couterpart.translate('work_order_customer_note')}: {this.state.workOrder.notesFromBuyer}
                          </p>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel>
                      <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      >
                      <Typography>{couterpart.translate('label_note')}</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <pre className="note-items">
                              { this.renderNotes() }
                          </pre>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <br/>
              </div>                           
          </div>                                                                                                                       
      </div>
      <div className="col-4">
          <div className="row">
              <label htmlFor="">Hinh Khach: { this.state.workOrder.imageURL }</label>
          </div>
          <div className="row">
              <WorkOrderAdditions mode="MODE_EDIT" 
                  caption={couterpart.translate('work_order_additions')} 
                  workOrderId={this.state.workOrder.id} 
                  isUpdated={this.state.updated}/> 
          </div>
          <div className="row">&nbsp;</div>                  
          <div className="row">
              <WorkOrderImages mode="MODE_EDIT" largeMode={1}  
                  workOrderId={this.state.workOrder.id} 
                  isUpdated={this.state.updated}/>
          </div>
      </div>
    </div>
    );
  }

  renderWorkOrderDialog(){
    return (
      <>
        <Modal
          show={this.state.show}
          onHide={() => this.setState({show: false})}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              { couterpart.translate('wo_details_title') } 
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            { this.renderWoDetails() }
          </Modal.Body>
        </Modal>
      </>
    )
  }

  getOrderNote(note){
      let idx = note.indexOf('order_note');
      if (idx >= 0){
          let dt = "";
          if (note.length > 18){
              dt = note.substring(0, 18) + ': ';
          }

          let orderNote = note.substring(idx);
          let idx2 = orderNote.indexOf('->');
          if (idx2 >= 0){
              let s = orderNote.substring(idx2)
              let idx3 = s.indexOf('\n\r  ');
              if (idx3 >= 0){
                  return dt + orderNote.substring(0, idx2 + idx3)
              }
              return dt + orderNote
          }
          return dt + orderNote;
      }
      return ''
  }  

  renderNotes(){
      if (this.state.notes === undefined){
          return "";
      }

      let s = "";
      for(let i=0; i< this.state.notes.length; i++){
          s += this.getOrderNote(this.state.notes[i].note) + "\r\n";
      }
      return s;
  }

  changeToReady(){
    let selectedItems = [];
    let notReadyCount = 0;
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true){
          if (this.state.selected[key].status !== WO_ASSIGNED_WORKER){
            notReadyCount++;
          } else {
            selectedItems.push(parseInt(key));
          }        
        }
      }
    }

    if (selectedItems.length < 1 || notReadyCount > 0) {
      alert(couterpart.translate('error_selected_assigned_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_change_to_ready_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            // this.setState({spinnerVisible: true}, () =>{
            WorkOrderDataService.changeToReady(selectedItems).then(data => {
              this.setState({ selected: {} }, () => {
                this.filterOrdersBy();
              });
            });
            // });        
          } catch (e) {
            // this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  resolveIncidents() {
    let selectedItems = [];
    let notResolveCount = 0;
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true){
          let fillSKU = this.state.selected[key].fillSKU;
          if (fillSKU.substring(0, 2) !== "Y$"){
            notResolveCount++;
          } else {
            selectedItems.push(parseInt(key));
          }        
        }
      }
    }

    if (selectedItems.length < 1 || notResolveCount > 0) {
      alert(couterpart.translate('error_selected_assigned_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_resolve_incident_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            WorkOrderDataService.resolveIncidents(selectedItems).then(data => {
              this.setState({ childRefreshCount: this.state.childRefreshCount + 1, selected: [] }, () => {
                this.filterOrdersBy();
              })

            });
          } catch (e) {
            // this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  renderReadyButton() {
    return (
      <button className="myButton"
        onClick={this.changeToReady.bind(this)}>
        <MdImportExport color={ICON_COLOR} />
        &nbsp;{couterpart.translate('button_ready')}
      </button>
    )
  }

  handleDonMuaSearchChange(e) {
    var value = e.target.value;
    this.setState({
      donMuaSearch: value
    });
  }

  handleHanGiaoMuaSearchChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddString(date);
    this.setState({
      hanGiaoMuaSearch: sDate
    });
  }

  handleHanGiaoMuaEndSearchChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddString(date);
    this.setState({
      hanGiaoMuaEndSearch: sDate
    });
  }

  renderDonMuaSearch() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService() && !AuthenticationService.isDesigner()  && !AuthenticationService.isShipping() && !AuthenticationService.isKhac()){
      return (<></>);
    }
    return(
      <>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <input type="text" defaultValue={this.state.donMuaSearch} style={{ width: '90%', marginTop: '5px', marginLeft: '0px' }}  placeholder="Don Mua(XMAS_24)" 
                onChange={this.handleDonMuaSearchChange.bind(this)}/>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div  style={{ width: '100%', marginTop: '5px' }}>
                  <DatePicker name="hanGiaoMuaSearch"
                              dateFormat="MM/dd/yyyy"
                              placeholderText={'Han Giao Mua Bat dau'}
                              selected={WorkOrderUtil.convertToDate(this.state.hanGiaoMuaSearch)}
                              onChange={this.handleHanGiaoMuaSearchChange.bind(this)} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div  style={{ width: '100%', marginTop: '5px'}}>
                  <DatePicker name="hanGiaoMuaEndSearch"
                              dateFormat="MM/dd/yyyy"
                              placeholderText={'Han Giao Mua Ket thuc'}
                              selected={WorkOrderUtil.convertToDate(this.state.hanGiaoMuaEndSearch)}
                              onChange={this.handleHanGiaoMuaEndSearchChange.bind(this)} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  render() {
    if (!AuthenticationService.isKhac() &&!AuthenticationService.isSupervisor()){
      return (<div>Unauthorized access.</div>);
    }

    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <br/>
              <div className="row border-top border-left border-right border-bottom border-light-gray"  style={{ margin: '2px'}}>
                <div className="col-12">
                  <div className="row"  style={{ margin: '2px'}}>
                    <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                      <div className="row">
                        <div className="col-2"><label><b>{couterpart.translate('order_date_from')}</b></label>:</div>
                        <div className="col-2">
                          <div className="customDatePickerWidth">
                            <DatePicker name="orderDateFrom" 
                              dateFormat="MM/dd/yyyy hh:mm"              
                              selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                              onChange={this.handleFromDateChange.bind(this)}/>
                          </div>
                        </div>
                        <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                        <div className="col-2">
                          <div className="customDatePickerWidth">
                            <DatePicker name="orderDateTo" 
                              dateFormat="MM/dd/yyyy hh:mm"
                              selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                              onChange={this.handleToDateChange.bind(this)}/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-1">
                      <input type="checkbox" value="1" onChange= {this.handleSemiClick.bind(this) } checked={this.state.semi == 1? true : false } /> <label> {couterpart.translate('wo_semi')} </label>
                    </div>
                    <div className="col-1">
                      <input type="checkbox" value="1" onChange= {this.handleIgnoreSemiClick.bind(this) } checked={this.state.ignoreSemi == 1? true : false } /> <label> {couterpart.translate('wo_ignore_semi')} </label>
                    </div>
                    <div className="col-1">
                      <input type="checkbox" value="Y" onChange= {this.handleIncidentClick.bind(this) } checked={this.state.incident === 'Y'? true : false } /> <label> {couterpart.translate('wo_incident')} </label>
                    </div>                
                  </div>
                  <div className="row" style={{ marginTop: '2px'}}>
                    <div className="col-1"><label style={{ padding: '5px'}}><b>{couterpart.translate('work_order_status')}</b></label></div>
                    <div className="col-4">
                      <Multiselect
                        options={this.state.woStatusList} 
                        selectedValues={this.state.selectedWoStatusList} 
                        onSelect={this.onSelect.bind(this)} 
                        onRemove={this.onRemove.bind(this)} 
                        displayValue="name"
                        showCheckbox={true} 
                      />                  
                    </div>
                    <div className="col-2">
                      <div className="row">
                        <div className="col-12">
                          <input type="text" defaultValue={this.state.orderNo} style={{ width: "100%" }}
                            placeholder={couterpart.translate('order_no')}
                            onChange={this.handleOrderNoChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }} />
                        </div>
                      </div>
                      <div className="row" style={{ marginTop: "5px" }}>
                        <div className="col-12">
                          <input type="text" defaultValue={this.state.pcode} style={{ width: "100%"}}
                            placeholder={couterpart.translate('shop_pcode')}
                            onChange={this.handlePcodeChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange(e) }, 0); }} />
                        </div>
                      </div>
                      <div className="row" style={{ marginTop: "5px" }}>
                        <div className="col-12">                
                          <input type="text" defaultValue={this.state.personalization} style={{ width: "100%" }}
                            placeholder={couterpart.translate('work_order_personalization')}
                            onChange={this.handlePersonalizationChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handlePersonalizationChange(e) }, 0); }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-1">
                      { this.renderWorkers() }
                    </div>
                    <div className="col-2">
                      { this.renderDonMuaSearch() }
                    </div>                
                    <div className="col-1">
                      <button className="myButton" 
                        onClick={this.onFilter.bind(this)}>
                        <FaFilter color={ICON_COLOR}/>
                        &nbsp;{couterpart.translate('button_filter')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row border-top border-left border-right border-bottom border-light-gray"  style={{ margin: '2px'}}>
                <div className="col-2">&nbsp;</div>
                <div className="col-2">
                  <button className="myButton" 
                    onClick={this.exportExcel.bind(this)}>
                    <MdImportExport color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_export')}
                  </button>
                </div>
                <div className="col-2">
                  <button className="myButton" 
                    onClick={this.changeWorkOrdersToCK.bind(this)}>
                    <MdImportExport color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_ck')}
                  </button>
                </div>
                <div className="col-2">
                  { this.renderReadyButton() }
                </div>
                <div className="col-2">
                  <button className="myButton" 
                    onClick={this.resolveIncidents.bind(this)}>
                    <MdImportExport color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_fix_ck')}
                  </button>
                </div>                            
              </div>           
              <div className="row">
                <div className="col-12">
                  <ReactTable
                    manual
                    NoDataComponent={() => null} 
                    previousText={"<"}
                    nextText={">"}
                    onPageChange={pageIndex => {
                      this.setState({ selectedPage: pageIndex }, () => {
                        this.filterOrdersBy()
                      })
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                      this.setState({ page: pageIndex, pageSize: pageSize }, () => {
                        this.filterOrdersBy()
                      });
                    }}
                    onSortedChange={sorted => {
                      let sortType = this.state.sortType === 'desc'? 'asc' : 'desc';
                      this.setState({
                        sortBy: sorted[0].id,
                        sortType: sortType 
                      }, () =>{
                        this.filterOrdersBy()
                      });
                    }}                                                 
                    data={this.state.workOrders}
                    loading= { this.state.loading }  
                    pages={ this.state.pages }
                    columns={this.state.columns}
                    defaultPageSize = {10}
                    showPageSizeOptions = {true}
                    pageSizeOptions = {[3, 5, 10, 20]}
                  />
                </div>
              </div>
              <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
              <Dialog ref={(component) => { this.dialog = component }} />
              { this.renderWorkOrderDialog() }
          </div>      
    )
  }
}
export default withRouter(KhacList);